import iconTypes from './constants/iconTypes';
import paths from './paths';

export { default as BOX_TYPES } from './constants/boxTypes';

export const ICON_TYPES = iconTypes;
export const PATHS = paths;
